module.exports = __webpack_public_path__ + "img/finished_check.fed20e6a.svg";